import styled from "styled-components";

import { theme } from "../../themes/themes";
export const Buttonlogin = styled.button`
  position: relative;
  background: ${({ theme }) => theme.button.primary};
  color: ${({ theme }) => theme.primaryColorLight};
  font-weight: 600;
  font-size: 14px;
  border: none;
  box-shadow: 0px 4px 18px ${({ theme }) => theme.shadows.medium};
  border-radius: 4px;
  width: 100%;
  height: 45px;
  margin: 20px 0;
  &:hover {
    opacity: 0.9;
  }

  @media (min-width: 2000px) {
    font-size: 16px;
  }
`;
export const SectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  width: 90%;
  margin: 20px auto;

  label,
  p {
    grid-column: 1/3;
    font-weight: 600;
    font-size: 20px;
    color: ${({ theme }) => theme.primary.purple};
    @media (min-width: 2000px) {
      font-size: 1.5rem;
    }
    @media (max-width: 768px) {
      font-size: 0.8rem;
      margin-bottom: 0;
    }
  }

  input,
  select {
    padding: 0.5em;
    grid-column: 1/3;
    width: 100%;
    border: 1px solid ${({ theme }) => theme.neutral.gray[900]};
    outline: 0;
    border-radius: 4px;
    box-sizing: border-box;
    font-size: 1rem;
    background-color: ${({ theme }) => theme.neutral.gray[200]};
    color: ${({ theme }) => theme.button.primary};
    @media (min-width: 2000px) {
      font-size: 14px;
    }
    @media (max-width: 768px) {
      height: 30px;
      font-size: 12px;
    }
  }

  input::placeholder {
    font-size: 0.8rem;
    @media (min-width: 2000px) {
      font-size: 12px;
    }
  }
  .username-field {
    background-image: url(${(props) => props.usernameIcon});
    background-position: 7px 50%;
    background-repeat: no-repeat;
    padding-left: 2em;
  }
  .password-field {
    background-image: url(${(props) => props.passwordIcon});
    background-position: 7px 50%;
    background-repeat: no-repeat;
    padding-left: 2em;
  }
`;
